// extracted by mini-css-extract-plugin
export var table = "_xj-0";